<template lang="pug">
  .urls
    .box.mt-4
      b-button(variant='primary' @click='openNewModal')
        font-awesome-icon(icon='plus-circle').mr-2
        | Lisa uus aadress

      b-table.mt-3(
        :items='urlsProvider'
        :fields='fields'
        :per-page='rowsPerPage'
        :current-page='currentPage'
        hover
        striped
        small
        responsive
        ref='addressesTable'
      )
        template(v-slot:cell(created_at)='data')
          | {{ formatDate(data.value) }}

        template(v-slot:cell(buttons)='data')
          .text-right
            b-button-group
              b-button(
                variant='primary'
                size='sm'
                v-b-popover.hover.top='"Kopeeri lühiaadress"'
                @click='openCopyModal(data.item)'
              )
                font-awesome-icon(icon='clipboard')
              b-button(
                variant='primary'
                size='sm'
                v-b-popover.hover.top='"Muuda"'
                @click='openEditModal(data.item)'
              )
                font-awesome-icon(icon='pencil-alt')
              b-button(
                variant='primary'
                size='sm'
                v-b-popover.hover.top='"Kustuta"'
                @click='confirmDeleteAddress(data.item)'
              )
                font-awesome-icon(icon='trash-alt')

      //- Pagination
      b-pagination(align='center' :total-rows='totalRows'
        :per-page='rowsPerPage' v-model='currentPage')

      //- New address modal
      b-modal(ref='newAddressModal')
        .mb-3
          label(for='short') Lühike aadress
          b-form-input(id='short' v-model='addressShort' trim)
        .mb-3
          label(for='long') Pikk aadress
          b-form-input(id='long' v-model='addressLong' trim)
        .mb-3
          label(for='utm-source') UTM source
          b-form-input(id='utm-source' v-model='utmSource' trim)
        .mb-3
          label(for='utm-medium') UTM medium
          b-form-input(id='utm-medium' v-model='utmMedium' trim)
        .mb-3
          label(for='utm-campaign') UTM campaign
          b-form-input(id='utm-campaign' v-model='utmCampaign' trim)
        .mb-3
          label(for='utm-term') UTM term
          b-form-input(id='utm-term' v-model='utmTerm' trim)
        div
          label(for='utm-content') UTM content
          b-form-input(id='utm-content' v-model='utmContent' trim)
        template(slot='modal-header')
          h4 Lisa uus aadress
        template(slot='modal-footer')
          b-btn(variant='primary' @click='submitNewAddress')
            font-awesome-icon(icon='check-circle').mr-2
            | Lisa
          b-btn(variant='primary' @click='closeNewModal')
            font-awesome-icon(icon='times-circle').mr-2
            | Tühista

      //- Edit address modal
      b-modal(ref='editAddressModal')
        .mb-3
          label(for='long') Pikk aadress
          b-form-input(id='long' v-model='addressLong' trim)
        .mb-3
          label(for='utm-source') UTM source
          b-form-input(id='utm-source' v-model='utmSource' trim)
        .mb-3
          label(for='utm-medium') UTM medium
          b-form-input(id='utm-medium' v-model='utmMedium' trim)
        .mb-3
          label(for='utm-campaign') UTM campaign
          b-form-input(id='utm-campaign' v-model='utmCampaign' trim)
        .mb-3
          label(for='utm-term') UTM term
          b-form-input(id='utm-term' v-model='utmTerm' trim)
        div
          label(for='utm-content') UTM content
          b-form-input(id='utm-content' v-model='utmContent' trim)
        template(slot='modal-header')
          h4 Muuda aadressi
        template(slot='modal-footer')
          b-btn(variant='primary' @click='submitEditedAddress')
            font-awesome-icon(icon='check-circle').mr-2
            | Muuda
          b-btn(variant='primary' @click='closeEditModal')
            font-awesome-icon(icon='times-circle').mr-2
            | Tühista

      //- Confirm delete modal
      b-modal(ref='confirmDeleteModal')
        div(v-if='addressToDelete !== undefined')
          | Lühike {{ addressToDelete.short }} <br/>
          | Pikk {{ addressToDelete.url }}
        template(slot='modal-header')
          h4 Kustuta aadress?
        template(slot='modal-footer')
          b-btn(variant='primary' @click='deleteAddress')
            font-awesome-icon(icon='check-circle').mr-2
            | Kustuta
          b-btn(variant='primary' @click='closeDeleteModal')
            font-awesome-icon(icon='times-circle').mr-2
            | Tühista

      //- Copy modal
      b-modal(ref='copyAddressModal' cancel-disabled)
        template(slot='modal-header')
          h4 Vali domeen
        template(slot='modal-footer')
          span
        .copy-modal
          .copy-modal-buttons
            b-btn(variant='primary' @click='copyShortAddress("toetan.nahtamatudloomad.ee")')
              font-awesome-icon.mr-2(icon='clipboard')
              | toetan.nahtamatudloomad.ee
            b-btn.mt-2(variant='secondary' @click='copyShortAddress("proovin.taimset.ee")')
              font-awesome-icon.mr-2(icon='clipboard')
              | proovin.taimset.ee
</template>

<script>
import { authBackend, formatDate } from '../api'

const fields = [
  {
    key: 'short',
    label: 'Lühike aadress'
  },
  {
    key: 'url',
    label: 'Pikk aadress'
  },
  {
    key: 'created_at',
    label: 'Loodud'
  },
  {
    key: 'buttons',
    label: ''
  }
]

export default {
  name: 'urls',

  data() {
    return {
      fields,
      rowsPerPage: 20,
      currentPage: 1,
      totalRows: 0,
      urls: [],

      addressShort: '',
      addressLong: '',
      utmSource: '',
      utmMedium: '',
      utmCampaign: '',
      utmTerm: '',
      utmContent: '',

      addressToEdit: undefined,
      addressToDelete: undefined,
      addressToCopy: undefined
    }
  },

  watch: {
    addressLong(newAddress) {
      const set = (param, setter) => {
        const url = URL.parse(newAddress)
        if (url === null) {
          return
        }
        const value = url.searchParams.get(param)
        if (value === null) {
          return
        }
        setter(value)
      }
      set('utm_source', (x) => { this.utmSource = x })
      set('utm_medium', (x) => { this.utmMedium = x })
      set('utm_campaign', (x) => { this.utmCampaign = x })
      set('utm_term', (x) => { this.utmTerm = x })
      set('utm_content', (x) => { this.utmContent = x })
    },
    utmSource(newSource) {
      this.setUrlParam('utm_source', newSource)
    },
    utmMedium(newMedium) {
      this.setUrlParam('utm_medium', newMedium)
    },
    utmCampaign(newCampaign) {
      this.setUrlParam('utm_campaign', newCampaign)
    },
    utmTerm(newTerm) {
      this.setUrlParam('utm_term', newTerm)
    },
    utmContent(newContent) {
      this.setUrlParam('utm_content', newContent)
    }
  },

  methods: {
    formatDate,

    urlsProvider(_ctx, callback) {
      this.fetchUrls().then(callback)
    },

    async fetchUrls() {
      const response = (
        await authBackend().get(
          '/api/short_url',
          {
            params: { page: this.currentPage - 1 }
          }
        )
      ).data
      this.urls = response.urls
      this.totalRows = response.totalRows
      return this.urls
    },

    refreshTable() {
      this.$refs.addressesTable.refresh()
    },

    openNewModal() {
      this.$refs.newAddressModal.show()
    },

    closeNewModal() {
      this.$refs.newAddressModal.hide()
      this.resetFields()
    },

    resetFields() {
      this.addressLong = ''
      this.addressShort = ''
      this.utmSource = ''
      this.utmMedium = ''
      this.utmCampaign = ''
      this.utmTerm = ''
      this.utmContent = ''
      this.addressToEdit = undefined
      this.addressToDelete = undefined
      this.addressToCopy = undefined
    },

    async submitNewAddress() {
      if (this.addressShort.length < 1) {
        alert('Lühike aadress puudub')
        return
      }
      if (this.addressLong.length < 1) {
        alert('Pikk aadress puudub')
        return
      }
      const req = { url: this.addressLong, short: this.addressShort }
      const res = await authBackend().post('/api/short_url', req, {
        validateStatus: (status) => (status >= 200 && status < 300) || status === 400
      })
      if (res.status === 400) {
        alert(res.data.message)
      } else if (res.status === 201) {
        this.closeNewModal()
        this.refreshTable()
      }
    },

    openEditModal(address) {
      this.addressToEdit = address.id
      this.addressLong = address.url
      this.$refs.editAddressModal.show()
    },

    closeEditModal() {
      this.$refs.editAddressModal.hide()
      this.resetFields()
    },

    async submitEditedAddress() {
      const req = { url: this.addressLong }
      await authBackend().patch(`/api/short_url/${this.addressToEdit}`, req)
      this.closeEditModal()
      this.refreshTable()
    },

    confirmDeleteAddress(address) {
      this.addressToDelete = address
      this.$refs.confirmDeleteModal.show()
    },

    closeDeleteModal() {
      this.$refs.confirmDeleteModal.hide()
    },

    async deleteAddress() {
      await authBackend().delete(`/api/short_url/${this.addressToDelete.id}`)
      this.addressToDelete = undefined
      this.$refs.confirmDeleteModal.hide()
      this.refreshTable()
    },

    openCopyModal(address) {
      this.addressToCopy = address
      this.$refs.copyAddressModal.show()
    },

    copyShortAddress(domain) {
      navigator.clipboard.writeText(`https://${domain}/${this.addressToCopy.short}`)
      this.$refs.copyAddressModal.hide()
      this.addressToCopy = undefined
    },

    setUrlParam(param, value) {
      const url = URL.parse(this.addressLong)
      if (url === null) {
        return
      }
      if (value === '') {
        url.searchParams.delete(param)
      } else {
        url.searchParams.set(param, value)
      }
      this.addressLong = url.toString()
    }
  }
}
</script>

<style lang="scss">
.copy-modal {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.copy-modal-buttons {
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;

  .btn {
    max-width: fit-content;
  }
}
</style>
